var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 32C8.55967 32 16.856 28.4444 16.856 15.2757V0H0V15.5391H9.3498C9.74486 22.7819 6.71605 26.7325 0 26.8642V32ZM25.1523 32C33.7119 32 42.0082 28.4444 42.0082 15.2757V0H25.1523V15.5391H34.5021C34.8971 22.7819 31.8683 26.7325 25.1523 26.8642V32Z"}));
}

Quote.defaultProps = {"width":"43","height":"32","viewBox":"0 0 43 32","fill":"#161616"};

module.exports = Quote;

Quote.default = Quote;
